export default __webpack_public_path__ + "static/compass-blue-70b98175593596cd8fe0f41a21c24b0d.jpg";